import { Container } from "components/common/container/Container";
import NavBar from "components/common/controls/navbar/NavBar";
import { IStyleableProps } from "lib/interfaces/IStyleableProps";
import { Padding } from "lib/styles/Padding";
import React, { Fragment } from "react";

interface ILayoutCentered extends IStyleableProps {
  navbarItemsLeft?: any[];
  navbarItemsRight?: any[];
}
export const LayoutCentered: React.FunctionComponent = (
  props: ILayoutCentered
) => {
  const { navbarItemsLeft, navbarItemsRight } = props;

  return (
    <Container fluid={true} centered={true} padding={Padding.small}>
      <Fragment>
        {navbarItemsLeft || navbarItemsRight ? (
          <NavBar
            leftItems={navbarItemsLeft || []}
            rightItems={navbarItemsRight || []}
          />
        ) : null}
        {props.children}
      </Fragment>
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/layout/centered/LayoutCentered.tsx